<template>
  <nav class="navbar navbar-expand-sm navbar-light menu-style fixed-top">
    <router-link to="/" class="navbar-brand web-version">
      <img
        v-if="pathAPI=='https://api.arkidia.com/ApiRes/'"
        src="public/images/site/logo-color.svg"
        height="40px"
        alt="Arkidia"
      />
      <img
        v-if="pathAPI!='https://api.arkidia.com/ApiRes/'"
        src="public/images/site/logo-color-dev.svg"
        height="40px"
        alt="Arkidia"
      />
    </router-link>
    <router-link to="/" class="navbar-brand responsive-version">
      <img
        v-if="pathAPI=='https://api.arkidia.com/ApiRes/'"
        src="public/images/site/logo-arkidia-solo.svg"
        height="40px"
        alt="Arkidia"
      />
      <img
        v-if="pathAPI!='https://api.arkidia.com/ApiRes/'"
        src="public/images/site/logo-arkidia-solo-dev.svg"
        height="40px"
        alt="Arkidia"
      />
    </router-link>

    <div
      class="navbar-toggler"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      style="border:0px; font-size:15px; display:flex"
    >
      <ul class="navbar-nav" style="display:contents">
        <router-link
          v-if="usuario.userLogged.profile == 'HIJO'"
          :to="'/Perfil/'+usuario.userLogged.user"
          tag="li"
          style="background: gainsboro;
                        border-radius: 20px;
                        padding: 0px 8px;
                        margin: 0px;
                        border: 0px;
                        margin-right:5px;
                        cursor:pointer"
        >
          <div style="display:inline-flex">
            <arkidian
              style=" border-radius:50%; width:30px; margin-top:0px; margin-bottom:4px"
              :preferencias="userLogged.preferencias"
            ></arkidian>
            <span style="padding-top:10px">{{this.userLogged.name}}</span>
          </div>
        </router-link>

        <router-link
          v-if="usuario.userLogged.profile == 'PADRE'"
          to="/"
          tag="li"
          style="background: gainsboro;
                        border-radius: 20px;
                        padding: 0px 8px;
                        margin: 0px;
                        border: 0px;
                        margin-right:5px;
                        cursor:pointer"
        >
          <img
            src="public/images/site/profile.svg"
            style=" border-radius:50%; width:30px; margin-top:0px; margin-bottom:4px"
            class="img img-rounded img-fluid"
          />
          {{this.userLogged.name}}
        </router-link>

        <router-link
          v-if="usuario.userLogged.profile == 'ADMINISTRADOR'"
          to="/"
          tag="li"
          style="background: gainsboro;
                        border-radius: 20px;
                        padding: 0px 8px;
                        margin: 0px;
                        border: 0px;
                        margin-right:5px;
                        cursor:pointer"
        >
          <img
            src="public/images/site/profile-admin.svg"
            style=" border-radius:50%; width:30px; margin-top:0px; margin-bottom:4px"
            class="img img-rounded img-fluid"
          />
          {{this.userLogged.name}}
        </router-link>

        <router-link
          v-if="usuario.userLogged.profile == 'HIJO'"
          to="/Notificaciones"
          tag="li"
          style="cursor:pointer; margin-left:5px"
        >
          <img
            v-if="counter>0"
            src="public/images/site/no-notifications.svg"
            style=" border-radius: 100%;
                    width: 33px;
                    margin-right: 20px;
                    padding: 4px;
                    background: #2dbacd;
                  "
            class="img img-rounded img-fluid"
          />
          <img
            v-if="counter==0"
            src="public/images/site/notifications.svg"
            style=" border-radius: 100%;
                    width: 33px;
                    margin-right: 20px;
                    padding: 4px;
                    background: #dcdcdc;
                  "
            class="img img-rounded img-fluid"
          />
        </router-link>

        <li v-if="usuario.userLogged.user" style="cursor:pointer" @click="logout()">
          <a
            style="    
                        background: gainsboro;
                        border-radius: 20px;
                        padding: 8px;
                        margin: 0px;
                        border: 0px;"
          >
            <img
              src="public/images/site/logout.svg"
              style=" border-radius:0%; width:20px; margin-top:5px; margin-bottom:10px;"
              class="img img-rounded img-fluid"
            />
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import Arkidian from "./shared/Arkidian";

export default {
  name: "app",
  data() {
    return {
      nombre: "",
      notificaciones: [],
      notificacionesVistas: []
    };
  },
  props: {
    usuario: ""
  },
  components: {
    arkidian: Arkidian
  },
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "usuarioSeleccionado",
      "pathAPI",
      "counter"
    ])
  },
  methods: {
    verNotificaciones() {
      this.$router.push({ path: "/Notificaciones" });
    },
    cantidadNotificaciones() {
      fetch(this.pathAPI + "notificaciones.php?usuario=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          var cont = 0;
          for (var i = 0; i < data.length; i++) {
            if (data[i].indicador_visto == "N") {
              cont++;
            }
          }
          this.$store.state.counter = cont;
        });
    },

    logout() {
      this.$store.state.userLogged.avatar = "";
      this.$store.state.userLogged.profile = "";
      this.$store.state.userLogged.name = "";
      this.$store.state.userLogged.user = "";
      sessionStorage.setItem("t", "");

      this.$router.push({ path: "/Gracias" });
    },

    irPerfil() {
      this.$store.state.usuarioSeleccionado = this.userLogged.user;
      sessionStorage.usuarioSeleccionado = this.userLogged.user;
      this.$router.push({ path: "/MiPerfil" });
    }
  },
  created: function() {
    if (this.userLogged.user) {
      this.userLogged.preferencias.animated = false;
      this.cantidadNotificaciones();
    }
  }
};
</script>


<style scoped>
.menu-style {
  background: #ececec;
}

i {
  cursor: pointer;
}

.web-version {
  display: block;
}
.responsive-version {
  display: none;
}

@media screen and (max-width: 768px) {
  .web-version {
    display: none;
  }
  .responsive-version {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue